import React, { useEffect, useState } from 'react';
import { Toast } from './Toast';
import { CreativeContext } from './CreativeContext';
import { AttentionBlueprint } from './AttentionBlueprint';
import { ExecutiveSummary } from './ExecutiveSummary';
import { ViewingContext } from './ViewingContext';
import { DriverAnalysis } from './DriverAnalysis';
import { SystemDynamics } from './SystemDynamics';
import { OverallAssessment } from './OverallAssessment';
import { TopStrengthsImprovements } from './TopStrengthsImprovements';
import { AttentionTestingCTA } from './AttentionTestingCTA';
import { oohData } from '../utils/oohData';
interface DashboardProps {
  timeRange: string;
}
export const Dashboard: React.FC<DashboardProps> = () => {
  const [showToast, setShowToast] = useState(false);
  useEffect(() => {
    // Reset localStorage for testing
    localStorage.removeItem('hasShownNotification');
    // Small delay to ensure component is mounted
    const timer = setTimeout(() => {
      if (window.innerWidth <= 1024) {
        setShowToast(true);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div id="report-root" className="space-y-6 relative" data-id="element-84">
      <Toast show={showToast} onClose={() => setShowToast(false)} data-id="element-85" />
      <div id="overview" data-id="element-86">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-87">
          OOH Attention Analysis Report
        </h1>
        <p className="text-gray-500 mb-8" data-id="element-88">
          Brandpulse • {oohData.brandContext.brandName} •{' '}
          {new Date().toLocaleDateString('en-GB', {
          month: 'long',
          year: 'numeric'
        })}
        </p>

        <div className="space-y-6" data-id="element-89">
          <CreativeContext data-id="element-90" />
          <AttentionBlueprint data-id="element-91" />
          <ExecutiveSummary data-id="element-92" />
          <ViewingContext data-id="element-93" />
        </div>
      </div>
      <div id="analysis" data-id="element-94">
        <DriverAnalysis data-id="element-95" />
      </div>
      <div id="dynamics" data-id="element-96">
        <SystemDynamics data-id="element-97" />
      </div>
      <div id="assessment" data-id="element-98">
        <OverallAssessment data-id="element-99" />
      </div>
      <div id="recommendations" data-id="element-100">
        <TopStrengthsImprovements data-id="element-101" />
      </div>
      <div id="next-step" data-id="element-102">
        <AttentionTestingCTA data-id="element-103" />
      </div>
    </div>;
};